import { getI18n } from '@bridebook/web/lib/i18n/getI18n';

export const IncludedInPricingLabels = {
  exclusiveUse: () => getI18n().t('supplier:pricing.label.exclusiveUse'),
  privateRoomIncluded: () => getI18n().t('supplier:pricing.label.privateRoomIncluded'),
  nonConsumables: () => getI18n().t('supplier:pricing.label.nonConsumables'),
  canapesIncluded: () => getI18n().t('supplier:pricing.label.canapesIncluded'),
  drinksAllowance: () => getI18n().t('supplier:pricing.label.drinksAllowance'),
  dayBeforeSetUp: () => getI18n().t('supplier:pricing.label.dayBeforeSetUp'),
  furnitureIncluded: () => getI18n().t('supplier:pricing.label.furnitureIncluded'),
  multipleCourseWeddingBreakfast: () =>
    getI18n().t('supplier:pricing.label.multipleCourseWeddingBreakfast'),
  coupleAccommodationIncluded: () =>
    getI18n().t('supplier:pricing.label.coupleAccommodationIncluded'),
  guestAccommodationIncluded: () =>
    getI18n().t('supplier:pricing.label.guestAccommodationIncluded'),
  weddingCoordinatorOnDay: () => getI18n().t('supplier:pricing.label.weddingCoordinatorOnDay'),
  choiceOfPreferredCaterers: () => getI18n().t('supplier:pricing.label.choiceOfPreferredCaterers'),
  externalCaterersNotPermitted: () =>
    getI18n().t('supplier:pricing.label.externalCaterersNotPermitted'),
  noCorkageFee: () => getI18n().t('supplier:pricing.label.noCorkageFee'),
  corkageChargeApplicable: () => getI18n().t('supplier:pricing.label.corkageChargeApplicable'),
  wineAllowancePerGuest: () => getI18n().t('supplier:pricing.label.wineAllowancePerGuest'),
  minimumNumbersApply: () => getI18n().t('supplier:pricing.label.minimumNumbersApply'),
  setMenuOptionsOnly: () => getI18n().t('supplier:pricing.label.setMenuOptionsOnly'),
  bespokeMenuAvailable: () => getI18n().t('supplier:pricing.label.bespokeMenuAvailable'),
  tableLinenIncluded: () => getI18n().t('supplier:pricing.label.tableLinenIncluded'),
  cutleryIncluded: () => getI18n().t('supplier:pricing.label.cutleryIncluded'),
  menuTastingIncluded: () => getI18n().t('supplier:pricing.label.menuTastingIncluded'),
  openBar: () => getI18n().t('supplier:pricing.label.openBar'),
  serviceStaff: () => getI18n().t('supplier:pricing.label.serviceStaff'),
};
